import moment from "moment-timezone";
import Swal from "sweetalert2";

const isTableauAvailable = (testDate = null) => {
  const currentTime = testDate
    ? moment.tz(testDate, "America/Denver")
    : moment.tz("America/Denver");

  const isFullyOff = currentTime.day() === 0 || currentTime.day() === 6;
  if (isFullyOff) {
    return false;
  }

  const startTime = moment.tz(
    currentTime.format("YYYY-MM-DD") + " 06:00:00",
    "America/Denver"
  );
  const endTime = moment.tz(
    currentTime.format("YYYY-MM-DD") + " 19:30:00",
    "America/Denver"
  );

  const alertTime = endTime.clone().subtract(30, "minutes");
  if (currentTime.isSame(alertTime, "minute")) {
    Swal.fire({
      title: "Reminder",
      text: "Tableau is only available 6am-7:30pm MST Monday-Friday",
      icon: "warning",
      confirmButtonText: "OK",
    });
  }

  const isInRange = currentTime.isBetween(startTime, endTime, null, "[]");
  return isInRange;
};

export default isTableauAvailable;
